import { Link } from '@tanstack/react-router';

/** On every page: the legal documents and who stands behind the brand. */
export function SiteFooter() {
  return (
    <footer className="border-t border-line">
      <div className="mx-auto flex w-full max-w-2xl flex-wrap items-center gap-x-2 gap-y-1 px-4 py-6 text-sm text-muted">
        <nav aria-label="Legal" className="flex items-center gap-x-2">
          <Link to="/legal/privacy">Privacy</Link>
          <span aria-hidden="true">·</span>
          <Link to="/legal/terms">Terms</Link>
        </nav>
        <span aria-hidden="true" className="max-sm:hidden">
          ·
        </span>
        <p className="max-sm:basis-full">Direwolf AI is a brand of Global-AI-Network LLC</p>
      </div>
    </footer>
  );
}
